import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data';

// Category → badge label + style class.
const CATEGORY = {
  Work: { label: 'Company', cls: 'work' },
  Client: { label: 'Client work', cls: 'client' },
  Personal: { label: 'Personal', cls: '' },
};

function ProjectCard({ p }) {
  const cat = CATEGORY[p.category] || CATEGORY.Personal;
  const hasLinks = p.links && (p.links.live || p.links.code);

  return (
    <article className="project-card card">
      <div className="project-top">
        <div className={`project-icon a-${p.accent}`}>
          <i className={p.icon}></i>
        </div>
        <span className={`badge-cat ${cat.cls}`}>{cat.label}</span>
      </div>
      <h3>{p.title}</h3>
      {p.company && (
        <div className="project-company">
          <i className="fa-solid fa-building"></i> {p.company}
        </div>
      )}
      <p>{p.description}</p>
      <div className="tech-row">
        {p.tech.map((t) => (
          <span key={t} className="tech-pill">
            {t}
          </span>
        ))}
      </div>
      <div className="project-links">
        {p.links?.live && (
          <a href={p.links.live} target="_blank" rel="noreferrer">
            <i className="fa-solid fa-arrow-up-right-from-square"></i> Live demo
          </a>
        )}
        {p.links?.code && (
          <a href={p.links.code} target="_blank" rel="noreferrer">
            <i className="fa-brands fa-github"></i> Source code
          </a>
        )}
        {!hasLinks && (
          <span className="project-private">
            <i className="fa-solid fa-lock"></i> Company project — private codebase
          </span>
        )}
      </div>
    </article>
  );
}

function Projects({ featured = false }) {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Work', 'Personal', 'Client'];

  const filterLabel = (f) =>
    f === 'All' ? 'All projects' : (CATEGORY[f] && CATEGORY[f].label) || f;

  const list = useMemo(() => {
    if (featured) return projects.slice(0, 3);
    if (filter === 'All') return projects;
    return projects.filter((p) => p.category === filter);
  }, [featured, filter]);

  return (
    <section className="section" id="projects">
      <div className="section-head reveal">
        <span className="eyebrow">
          <i className="fa-solid fa-folder-open"></i> Portfolio
        </span>
        <h2 className="section-title">
          {featured ? 'Featured ' : ''}
          <span className="gradient-text">projects</span>
        </h2>
        <p className="section-sub">
          Company work at Octalogic Tech, personal builds, and freelance client projects — from
          real-time platforms to e-commerce.
        </p>
      </div>

      {!featured && (
        <div className="filter-bar">
          {filters.map((f) => (
            <button
              key={f}
              className={`filter-btn ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {filterLabel(f)}
            </button>
          ))}
        </div>
      )}

      <div className="projects-grid">
        {list.map((p) => (
          <ProjectCard key={p.title} p={p} />
        ))}
      </div>

      {featured && (
        <div style={{ textAlign: 'center', marginTop: 36 }}>
          <Link to="/projects" className="btn btn-ghost">
            View all projects <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>
      )}
    </section>
  );
}

export default Projects;
